import React, {FC, useEffect, useMemo, useRef, useState} from 'react';
import {formatDate, isDateTodayOrTomorrow} from "../../../../../utils/helpers/dateHelpers/dateHelpers";
import {useAppDispatch, useAppSelector} from "../../../../../store/store";
import {updateOrderRequestFavorite} from "../../../../../store/reducers/freighterRequestsReducer/freighterRequestsReducer";
import {useChat} from "../../../../../components/businessCommon/chat/useChat";
import styled from "styled-components";
import defaultAvatar from "../../../../../media/images/default_avatar.png";
import TrashIcon from "../../../../../media/icons/delete.svg?react";
import CloseIcon from "../../../../../media/icons/close.svg?react";
import FlagIcon from "../../../../../media/icons/flag.svg?react";
import FlagFilledIcon from "../../../../../media/icons/flag_filled.svg?react";
import DocumentSearchIcon from "../../../../../media/icons/document-search.svg?react";
import CaretRight from "../../../../../media/icons/caret_right.svg?react";
import CaretLeft from "../../../../../media/icons/caret_left.svg?react";
import {Tooltip, message} from "antd";
import {
  OrderRequestBrokerDrawer
} from "../../../../../components/businessCommon/brokerDrawer/wrappers/OrderRequestBrokerDrawer";
import {
  OrderRequestOrderRouteFlightDrawer
} from "../../../../../components/businessCommon/flightDrawer/wrappers/OrderRequestOrderRouteFlightDrawer";
import {ChatModal} from "../../../../../components/businessCommon/chat/ChatModal";
import {ArchiveOrderRequestModal} from "./ArchiveOrderRequestModal";
import {PastResponsesModal} from "../../../Shared/components/PastResponsesModal";
import {DisplayManagerFullName} from "../../../../../utils/helpers/textDisplayHelpers/DisplayFullName";
import {defineMessages, useIntl} from "react-intl";
import {CommonButtonMessages} from "../../../../../intl/commonMessages/CommonButtonMessages";
// import {MakeOfferDrawer} from "./MakeOfferDrawer";
import {
  RequestOffer,
  RespondToRequestModal,
  respondModalMockOffers
} from "./RespondToRequestModal";
import {ScheduleCreateFromOrderModal} from "../../Schedule/components/ScheduleCreateFromOrderModal";
import {Logger} from "../../../../../utils/logger/Logger";
import {ChatButton} from "../../../../../components/businessCommon/chat/ChatButton";
import {
  IFreighterOrderRequest
} from "../../../../../store/reducers/freighterRequestsReducer/freighterRequestsReducerTypes";
import {VerticalDivider} from "../../../../../components/UI/VerticalDivider/VerticalDivider";
import {FlyRouteMini} from "../../../../../components/businessCommon/flyRoute/FlyRouteMini";
import {IAirport, ICurrency} from "../../../../../store/reducers/fleetReducer/fleetReducerTypes";
import {OrderTypeShield} from "../../../../../components/businessCommon/orderType/OrderTypeShield";
import {CustomButton} from "../../../../../components/UI/AntCustom/CustomButton";
import {OrderStatusEnum} from "../../../../../store/reducers/chartererRequestsReducer/chartererRequestsReducerTypes";
import {DisplayFlyPrice} from "../../../../../utils/helpers/textDisplayHelpers/DisplayFlyPrice";
import {readNotifications} from "../../../../../store/reducers/notificationsReducer/notificationsReducer";
import {NotificationType} from "../../../../../store/reducers/notificationsReducer/notificationsReducerTypes";
import {useIsMobile} from "../../../../../hooks/useWindowSize";
import {mediaScreenSizes, screenSizes} from "../../../../../utils/constans/styles/screenSizes";
import {CustomLinkButton} from "../../../../../components/UI/Buttons/CustomLinkButton";
import {OrderRequestStatusEnum, OrderRequestPlaneStatusEnum} from "../../../../../utils/constans/statuses/orderRequestStatuses";
import {useUserTimezoneOffset} from "../../../../../hooks/useUserTimezone";
import type {ItineraryLeg} from "./ArchiveOrderRequestModal";

const OrderRequestCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  flex-wrap: nowrap;
`;

const OrderRequestCardWrapperMobile = styled.div`
  background: #fafafa;
  border: 1px solid #D9D9D9;
  border-radius: 10px;
  padding: 13px 16px 24px 16px;
  display: flex;
  flex-direction: column;
`;

const OrderRequestCardOrderTypeAndRouteMobile = styled.div<{ isOrderDeclined: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  margin: 16px 0;

  & > *:first-child {
    opacity: ${props => props.isOrderDeclined ? 0.3 : 1};
  }
  & > *:last-child > *:first-child {
    opacity: ${props => props.isOrderDeclined ? 0.3 : 1};
  }
`;

const OrderRequestOrderRoutesAndStatusMobile = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const OrderRequestCardBroker = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  background: #FAFAFA;
  border: 1px solid #D9D9D9;
  border-radius: 10px;
  padding: 13px 10px 14px 16px;
  width: 250px;
  min-width: 250px;
`;

const OrderRequestBrokerInfo = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;

  & > img {
    width: 60px;
    height: 60px;
    border-radius: 100%;
    object-fit: cover;
  }

  & > div {
    display: flex;
    flex-direction: column;

    div {
      :nth-child(1) {
        font-weight: 500;
        font-size: 10px;
        line-height: 12px;
        margin-bottom: 2px;
        color: #040404;
      }

      :nth-child(2) {
        font-weight: 700;
        font-size: 14px;
        line-height: 22px;
        color: #000000;
        letter-spacing: -0.01em;
      }

      :nth-child(3) {
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        color: #1890FF;
        cursor: pointer;
      }
    }
  }

  @media (max-width: ${mediaScreenSizes.mobile}) {
    & > img {
      width: 44px;
      height: 44px;
      border-radius: 100%;
      object-fit: cover;
    }

    padding-bottom: 8px;
    border-bottom: 1px solid #D9D9D9;
  }
`;

const OrderRequestCardOrder = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  background: #FAFAFA;
  border: 1px solid #D9D9D9;
  border-radius: 10px;
  padding: 16px 16px 17px 16px;
  flex-grow: 1;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
`;

const OrderRequestOrderType = styled.div<{ isOrderDeclined: boolean }>`
  display: flex;
  align-items: center;
  width: max-content;
  min-width: 95px;
  flex-shrink: 0;
  opacity: ${props => props.isOrderDeclined ? 0.3 : 1};

  @media (min-width: ${screenSizes.mobile + 1}px) and (max-width: 999px) {
    width: 100%;
    min-width: unset;
  }
`;

const OrderRequestOrderRoutes = styled.div<{ isOrderDeclined?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 0 8px;
  align-items: flex-start;
  justify-content: center;
  row-gap: 7px;
  flex-grow: 1;
  flex-shrink: 0;

  & > div:nth-child(1) {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #808080;
  }

  & > div:nth-child(2) {
    font-size: 12px;
    line-height: 15px;

    & * {
      font-size: inherit;
    }
  }

  @media (max-width: ${mediaScreenSizes.mobile}) {
    padding: 0;
  }
`;

const OrderRequestOfferSection = styled.div`
  min-width: 253px;
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;

const DeclinedShield = styled.div`
  padding: 4px 24px;
  background: #E7C4C4;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  margin: auto 0;
  border-radius: 23px;
  flex-shrink: 0;
`;

const ActionButtonWrapper = styled(CustomButton)`
  width: 45px;
  height: 35px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FAFAFA;
  border: 1px solid #D9D9D9;
  border-radius: 5px;
  
  svg {
    width: 16px;
    height: 16px;
  }
  
  .anticon {
    width: 10px;
    height: 10px;
    margin-left: 4px;
  }

  &:hover {
    border-color: #1890FF;
  }
`;

const FavoriteButtonWrapper = styled(CustomButton)<{ $isFavorite?: boolean }>`
  width: 45px;
  height: 35px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FAFAFA;
  border: 1px solid ${props => props.$isFavorite ? '#1890FF' : '#D9D9D9'};
  border-radius: 5px;
  color: rgba(0, 0, 0, 0.88);

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    border-color: #1890FF !important;
    color: rgba(0, 0, 0, 0.88) !important;
  }
`;

const StatusButton = styled.button<{ $variant: "accept" | "decline"; $active: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: ${({$active, $variant}) =>
    $active ? "none" : $variant === "accept" ? "1px solid #808080" : "1px solid #808080"};
  background-color: ${({$active, $variant}) => {
    if (!$active) return "transparent";
    return $variant === "accept" ? "#448df7" : "#ff3b30";
  }};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  color: ${({$active}) => ($active ? "#ffffff" : "#8c8c8c")};
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
    
    path {
      fill: currentColor;
    }
  }

  &:hover {
    background-color: ${({$variant}) => ($variant === "accept" ? "#3a7fe0" : "#e6332a")};
    border-color: transparent;
    color: #fff;
    
    svg {
      path {
        fill: #ffffff;
      }
    }
  }
`;

const OfferDetails = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border-radius: 5px;
  border: 1px solid #D9D9D9;
  flex-grow: 1;

  & > svg > path {
    fill: #448EF7;
  }

  & > div {
    padding: 3px;
    display: flex;
    flex-direction: row;
    column-gap: 8px;

    img {
      width: 44px;
      height: 44px;
      object-fit: cover;
      border-radius: 3px;
    }

    & > div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      row-gap: 2px;

      & > div {
        :nth-child(1) {
          font-weight: 600;
          font-size: 14px;
          line-height: 17px;
          color: #000000;
        }

        :nth-child(2) {
          font-weight: 500;
          font-size: 12px;
          line-height: 14px;
          color: #808080;
        }
      }
    }
  }
`;


const OfferDetailsMobile = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border: 1px solid #1890FF;
  border-radius: 5px;

  & > svg > path {
    fill: #1890FF;
  }

  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 8px;

    & > img {
      border-radius: 100%;
      width: 44px;
      height: 44px;
      object-fit: cover;
    }

    & > div > div {
      :nth-child(1) {
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #000000;
      }

      :nth-child(2) {
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        color: #808080;
      }
    }
  }
`;

const OrderVerticalDivider = styled(VerticalDivider)`
  @media (min-width: ${screenSizes.mobile + 1}px) and (max-width: 999px) {
    display: none;
  }
`;

const PlanesSummarySection = styled.div`
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  padding: 3px 4px 3px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 150px;
  flex-shrink: 0;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }

  & > div:first-child {
    display: flex;
    flex-direction: column;
    gap: 2px;
    align-items: flex-start;

    & > div:first-child {
      font-weight: 600;
      font-size: 14px;
      line-height: 1.2;
      color: #000000;
    }

    & > div:last-child {
      font-weight: 500;
      font-size: 12px;
      line-height: 1.2;
      color: #808080;
    }
  }

  & > div:last-child {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    svg {
      width: 21px;
      height: 21px;
      
      path {
        fill: #448EF7;
      }
    }
  }

  @media (max-width: ${mediaScreenSizes.mobile}) {
    margin-top: 8px;
  }
`;


const UrgentDate = styled.span<{isUrgent: boolean}>`
  color: ${props => props.isUrgent ? '#FF3B30' : 'inherit'};
  font-weight: 'normal';
`;

const OrderRequestCardMessages = defineMessages({
  offer: {
    id: "orderRequestCardMessages.offer",
    defaultMessage: "Offer",
  },
  makeOffer: {
    id: "orderRequestCardMessages.makeOffer",
    defaultMessage: "Make offer",
  },
  orderRouteArchivedByBroker: {
    id: "orderRequestCardMessages.orderRouteArchivedByBroker",
    defaultMessage: "Declined",
  },
  addToSchedule: {
    id: "orderRequestCardMessages.addToSchedule",
    defaultMessage: "Added to schedule",
  },
  addToSchedulePublic: {
    id: "orderRequestCardMessages.addToSchedulePublic",
    defaultMessage: "Add to schedule (Public)",
  },
  addToSchedulePrivate: {
    id: "orderRequestCardMessages.addToSchedulePrivate",
    defaultMessage: "Add to schedule (Private)",
  },
  quickAddToSchedule: {
    id: "orderRequestCardMessages.quickAddToSchedule",
    defaultMessage: "Quick add to schedule",
  },
})

const formatFlightDuration = (hours?: number, minutes?: number) => {
  const safeHours = hours ?? 0;
  const safeMinutes = minutes ?? 0;

  if (!safeHours && !safeMinutes) {
    return "—";
  }

  const parts: string[] = [];
  if (safeHours) {
    parts.push(`${safeHours}h`);
  }
  if (safeMinutes) {
    parts.push(`${safeMinutes}m`);
  }

  return parts.join(" ");
};


interface IOrderRequestCard {
  orderRequest: IFreighterOrderRequest;
  onOfferSubmitSuccess?: () => void; // Callback для обновления списка после успешной отправки предложения
}

export const OrderRequestCard: FC<IOrderRequestCard> = ({orderRequest, onOfferSubmitSuccess}) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const isMobile = useIsMobile();
  const offset = useUserTimezoneOffset();
  const userId = useAppSelector(state => state.user.oneItemObject.item.id)
  const [isChatOpened, setIsChatOpened] = useState<boolean>(false);
  const [isArchiveModalOpen, setIsArchiveModalOpen] = useState<boolean>(false);
  // const [isMakeOfferDrawerOpen, setIsMakeOfferDrawerOpen] = useState<boolean>(false);
  const [isRespondModalVisible, setIsRespondModalVisible] = useState<boolean>(false);
  const [isRespondModalReadOnly, setIsRespondModalReadOnly] = useState<boolean>(false);
  const [isBrokerDrawerOrderRequestOpen, setIsBrokerDrawerOrderRequestOpen] = useState<boolean>(false);
  const [isFlightDrawerOrderRequestOpen, setIsFlightDrawerOrderRequestOpen] = useState<boolean>(false);
  const [isPastResponsesModalOpen, setIsPastResponsesModalOpen] = useState<boolean>(false);
  const [isScheduleCreateModalOpen, setIsScheduleCreateModalOpen] = useState<boolean>(false);
  const [isFavorite, setIsFavorite] = useState<boolean>(orderRequest.isFavorite);
  const chat = useChat(userId, orderRequest.order.manager.id, orderRequest.order.orderId);
  const allUnreadNotifications = useAppSelector(state => state.notifications.unreadOnlyNotifications)
  useEffect(() => {
    setIsFavorite(orderRequest.isFavorite);
  }, [orderRequest.isFavorite]);

  //TODO ask about order request notifications reading
  // const hasNotifications = useMemo(() => {
  //   const unreadNotifications = allUnreadNotifications.filter(n => n.metadata.orderRequestId === orderRequest.id);
  //   if (unreadNotifications.length > 0) {
  //     dispatch(readNotifications({
  //       notificationIds: unreadNotifications.filter(n => n.type !== NotificationType.TYPE_INCOME_MESSAGE).map(n => n.id)
  //     }));
  //   }
  //   return unreadNotifications.length > 0;
  // }, []);

  const unreadChatNotifications = useMemo(() => allUnreadNotifications.filter(n => n.entityId === chat?.chatId
    && n.metadata.orderRequestId === orderRequest.id), [allUnreadNotifications]);

  const handleDocumentSearch = () => {
    setIsPastResponsesModalOpen(true);
  };

  if (!chat)
    Logger.info(`No chat found for: userId (account owner): ${userId}, agencyManagerId: ${orderRequest.order.manager.id}, orderId: ${orderRequest.order.orderId}`)

  const renderDateWithUrgency = (date: Date, timezoneOffset: number, format: string) => {
    const isUrgent = isDateTodayOrTomorrow(date, timezoneOffset);
    return (
      <UrgentDate isUrgent={isUrgent}>
        {formatDate(date, timezoneOffset, format as any)}
      </UrgentDate>
    );
  };

  const onChatOpen = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    setIsChatOpened(true);
  }

  const archiveItinerary: ItineraryLeg[] = useMemo(() => orderRequest.orderRouteOrderRequests.map(r => ({
    airport_from_code: r.orderRoute?.airportFrom?.icaoCode || r.orderRoute?.airportFrom?.iataCode,
    airport_to_code: r.orderRoute?.airportTo?.icaoCode || r.orderRoute?.airportTo?.iataCode,
  })), [orderRequest.orderRouteOrderRequests]);

  const allOrderAirports: IAirport[] = useMemo(() => orderRequest.orderRouteOrderRequests.reduce((acc, cur, index) => {
    if (index === 0)
      acc.push(cur.orderRoute.airportFrom);

    acc.push(cur.orderRoute.airportTo);
    return acc;
  }, [] as IAirport[]), [orderRequest.orderRouteOrderRequests])

  const requestTitle = useMemo(() => {
    return orderRequest.order?.company?.name || DisplayManagerFullName(orderRequest.order.manager);
  }, [orderRequest]);

  const respondModalOffers = useMemo<RequestOffer[]>(() => {
    // Если нет маршрутов, возвращаем пустой массив - модалка должна работать с реальными данными
    if (!orderRequest.orderRouteOrderRequests.length) {
      return [];
    }

    // Берем первый маршрут для формирования базовых данных
    const firstRoute = orderRequest.orderRouteOrderRequests[0];
    const lastRoute = orderRequest.orderRouteOrderRequests[orderRequest.orderRouteOrderRequests.length - 1];

    // Формируем даты и время из первого и последнего маршрута в UTC (для модалки RespondToRequestModal)
    const departureDate = formatDate(firstRoute.orderRoute.departureDate, 0, "date");
    const departureTime = formatDate(firstRoute.orderRoute.departureDate, 0, "time");
    
    // Для arrival берем дату из последнего маршрута или из arrivalDate если есть
    const arrivalDateSource = lastRoute.arrivalDate ?? lastRoute.orderRoute.departureDate;
    const arrivalDate = formatDate(arrivalDateSource, 0, "date");
    const arrivalTime = formatDate(arrivalDateSource, 0, "time");

    // Суммируем время полета и заправки по всем маршрутам
    const totalFlyMinutes = orderRequest.orderRouteOrderRequests.reduce((sum, route) => {
      const routeMinutes = (route.flyHours ?? 0) * 60 + (route.flyMinutes ?? 0);
      return sum + routeMinutes;
    }, 0);
    const totalFlyHours = Math.floor(totalFlyMinutes / 60);
    const totalFlyMinutesRemainder = totalFlyMinutes % 60;
    const flightDuration = formatFlightDuration(totalFlyHours, totalFlyMinutesRemainder);

    // Берем максимальное количество пассажиров из всех маршрутов
    const passengers = Math.max(...orderRequest.orderRouteOrderRequests.map(route => route.orderRoute.pax ?? 0), 0);

    // Суммируем количество заправок по всем маршрутам
    const refuels = orderRequest.orderRouteOrderRequests.reduce((sum, route) => {
      return sum + (route.technicalStopCount ?? 0);
    }, 0);

    // Формируем данные о запрошенной цене (broker's requested price)
    const brokerRequestedAmount =
      typeof orderRequest.price === "number"
        ? new Intl.NumberFormat("ru-RU").format(orderRequest.price)
        : "—";
    const brokerRequestedCurrency = orderRequest.currency?.name ?? "";
    const brokerRequestedCurrencyId = orderRequest.currency?.id;

    // Если есть planeList, создаем офферы на основе данных из planeList
    if (orderRequest.planeList && orderRequest.planeList.length > 0) {
      return orderRequest.planeList
        .filter((planeItem) => {
          // Фильтруем только самолеты с валидным registrationNumber и planeId
          const hasRegistrationNumber = planeItem.plane?.registrationNumber && planeItem.plane.registrationNumber.trim() !== '';
          const hasPlaneId = planeItem.planeId || planeItem.plane?.id;
          if (!hasRegistrationNumber) {
            console.warn('[OrderRequestCard] Skipping plane without registrationNumber:', {
              orderRequestPlaneId: planeItem.orderRequestPlaneId,
              planeId: planeItem.planeId,
              plane: planeItem.plane
            });
          }
          if (!hasPlaneId) {
            console.warn('[OrderRequestCard] Skipping plane without planeId:', {
              orderRequestPlaneId: planeItem.orderRequestPlaneId,
              planeId: planeItem.planeId,
              planeIdFromPlane: planeItem.plane?.id,
              plane: planeItem.plane
            });
          }
          return hasRegistrationNumber && hasPlaneId;
        })
        .map((planeItem) => {
        // Проверяем статус самолета - только статус 5 (APPROVED_BY_BROKER) должен быть accepted
        const isApprovedByBroker = planeItem.orderRequestStatusId === 5;
        const defaultStatus: RequestOffer["status"] = isApprovedByBroker ? "accepted" : "pending";

        // Используем данные из planeList
        const aircraftCode = planeItem.plane!.registrationNumber!; // Safe to use ! here because we filtered above
        
        // Use plane's currency (from calculator) as the main currency for requested price
        const planeCurrency = planeItem.plane?.flyHourCurrency;
        const planeCurrencyId = planeCurrency?.id;
        const planeCurrencyName = planeCurrency?.name || "";
        
        // Use plane's currency as the main currency for requested price display
        // Pass broker's currency ID so modal can convert broker's price to plane's currency
        const requestedCurrency = planeCurrencyName || brokerRequestedCurrency;
        const requestedCurrencyId = planeCurrencyId || brokerRequestedCurrencyId;
        const requestedAmount = brokerRequestedAmount; // Broker's requested amount (will be converted to plane's currency in modal if needed)
        
        // Keep price input empty by default - operator should enter their own price
        const offerAmount = "";
        const offerCurrency = planeItem.operatorCurrency?.name || planeItem.currency?.name || requestedCurrency || "USD";
        const offerCurrencyId = planeItem.operatorCurrencyId || planeItem.currency?.id;

        // Конвертируем flightDurationMinutes в формат "Xh Ym"
        let planeFlightDuration = flightDuration; // По умолчанию используем расчетное значение
        if (planeItem.flightDurationMinutes !== undefined && planeItem.flightDurationMinutes !== null) {
          const planeTotalMinutes = planeItem.flightDurationMinutes;
          const planeHours = Math.floor(planeTotalMinutes / 60);
          const planeMinutes = planeTotalMinutes % 60;
          planeFlightDuration = formatFlightDuration(planeHours, planeMinutes);
        }

        // Use adjusted departure and arrival times from planesList if available
        let planeDepartureDate = departureDate;
        let planeDepartureTime = departureTime;
        let planeArrivalDate = arrivalDate;
        let planeArrivalTime = arrivalTime;
        
        // Parse adjusted departure date/time from planeItem (format: "Y-m-d H:i:s")
        if (planeItem.departureDate) {
          try {
            const adjustedDeparture = new Date(planeItem.departureDate);
            if (!isNaN(adjustedDeparture.getTime())) {
              planeDepartureDate = formatDate(adjustedDeparture, 0, "date");
              planeDepartureTime = formatDate(adjustedDeparture, 0, "time");
            }
          } catch (error) {
            console.error('[OrderRequestCard] Error parsing departureDate:', error);
          }
        }
        
        // Parse adjusted arrival date/time from planeItem (format: "Y-m-d H:i:s")
        if (planeItem.arrivalDate) {
          try {
            const adjustedArrival = new Date(planeItem.arrivalDate);
            if (!isNaN(adjustedArrival.getTime())) {
              planeArrivalDate = formatDate(adjustedArrival, 0, "date");
              planeArrivalTime = formatDate(adjustedArrival, 0, "time");
            }
          } catch (error) {
            console.error('[OrderRequestCard] Error parsing arrivalDate:', error);
            // Fallback: calculate arrival from departure + flightDurationMinutes
            if (planeItem.flightDurationMinutes !== undefined && planeItem.flightDurationMinutes !== null) {
              const adjustedDeparture = planeItem.departureDate ? new Date(planeItem.departureDate) : firstRoute.orderRoute.departureDate;
              if (!isNaN(adjustedDeparture.getTime())) {
                const calculatedArrivalDate = new Date(adjustedDeparture.getTime() + planeItem.flightDurationMinutes * 60000);
                planeArrivalDate = formatDate(calculatedArrivalDate, 0, "date");
                planeArrivalTime = formatDate(calculatedArrivalDate, 0, "time");
              }
            }
          }
        } else if (planeItem.flightDurationMinutes !== undefined && planeItem.flightDurationMinutes !== null) {
          // Fallback: calculate arrival from adjusted departure + flightDurationMinutes
          const adjustedDeparture = planeItem.departureDate ? new Date(planeItem.departureDate) : firstRoute.orderRoute.departureDate;
          if (!isNaN(adjustedDeparture.getTime())) {
            const calculatedArrivalDate = new Date(adjustedDeparture.getTime() + planeItem.flightDurationMinutes * 60000);
            planeArrivalDate = formatDate(calculatedArrivalDate, 0, "date");
            planeArrivalTime = formatDate(calculatedArrivalDate, 0, "time");
          }
        }

        return {
          id: `${orderRequest.id}-${planeItem.orderRequestPlaneId}-${firstRoute.orderRoute.id}`,
          aircraftCode,
          planeId: planeItem.planeId || planeItem.plane?.id, // Use planeId from planeItem, fallback to plane.id if needed
          orderRequestPlaneId: planeItem.orderRequestPlaneId, // Сохраняем для обновления существующего предложения
          departureDate: planeDepartureDate,
          departureTime: planeDepartureTime,
          arrivalDate: planeArrivalDate,
          arrivalTime: planeArrivalTime,
          requestedAmount,
          requestedCurrency,
          requestedCurrencyId,
          brokerRequestedCurrencyId, // Pass broker's currency ID for conversion
          offerAmount,
          offerCurrency,
          offerCurrencyId,
          flightDuration: planeFlightDuration,
          passengers,
          refuels: planeItem.refuelingCount ?? refuels, // Используем refuelingCount из planeList если есть
          status: defaultStatus,
          positioningDurationMinutes: planeItem.positioningDurationMinutes,
          positioningDistanceKm: planeItem.positioningDistanceKm,
          positioningFromAirportId: planeItem.positioningFromAirportId,
          positioningDepartureDate: planeItem.positioningDepartureDate,
        };
      });
    }

    // Если planeList пустой, проверяем, есть ли одиночный plane на orderRequest
    // (это может быть случай, когда backend не отправляет planeList с рассчитанными таймингами)
    if (orderRequest.plane && orderRequest.plane.registrationNumber && orderRequest.plane.registrationNumber.trim() !== '') {
      const planeId = orderRequest.plane.id;
      const aircraftCode = orderRequest.plane.registrationNumber;
      
      return [{
        id: `${orderRequest.id}-${firstRoute.orderRoute.id}`,
        aircraftCode,
        planeId: planeId,
        departureDate,
        departureTime,
        arrivalDate,
        arrivalTime,
        requestedAmount: brokerRequestedAmount,
        requestedCurrency: brokerRequestedCurrency,
        requestedCurrencyId: brokerRequestedCurrencyId,
        brokerRequestedCurrencyId,
        offerAmount: "",
        offerCurrency: orderRequest.plane.flyHourCurrency?.name || brokerRequestedCurrency || "USD",
        offerCurrencyId: orderRequest.plane.flyHourCurrency?.id || orderRequest.currency?.id,
        flightDuration,
        passengers,
        refuels,
        status: "pending"
      }];
    }
    
    // Если planeList пустой и нет одиночного plane, создаем пустой оффер для добавления самолета
    const offerCurrency = brokerRequestedCurrency || "USD";
    const offerCurrencyId = orderRequest.currency?.id;

    const offer: RequestOffer = {
      id: `${orderRequest.id}-${firstRoute.orderRoute.id}`,
      aircraftCode: "",
      planeId: undefined,
      departureDate,
      departureTime,
      arrivalDate,
      arrivalTime,
      requestedAmount: brokerRequestedAmount,
      requestedCurrency: brokerRequestedCurrency,
      requestedCurrencyId: brokerRequestedCurrencyId, // No plane, so use broker's currency
      brokerRequestedCurrencyId, // Pass broker's currency ID
      offerAmount: "",
      offerCurrency,
      offerCurrencyId,
      flightDuration,
      passengers,
      refuels,
      status: "pending"
    };

    Logger.collapsedLog('[respondModalOffers] Generated offer from orderRequest', {
      orderRequestId: orderRequest.id,
      offer,
      orderRequestData: {
        price: orderRequest.price,
        currency: orderRequest.currency?.name,
        planeListCount: orderRequest.planeList?.length || 0,
        routesCount: orderRequest.orderRouteOrderRequests.length,
      }
    }, 'green');

    return [offer];
  }, [orderRequest, offset]);

  const isOrderDeclinedByBroker = orderRequest.order.isArchived && !orderRequest.isArchived;

  const firstRoute = orderRequest.orderRouteOrderRequests[0].orderRoute;
  const lastRoute = orderRequest.orderRouteOrderRequests.slice(-1)[0].orderRoute;
  const isOnlyRoute = firstRoute.id === lastRoute.id;

  // Ищем самолет со статусом STATUS_APPROVED_BY_BROKER (одобрено брокером) в planeList
  const approvedPlane = useMemo(() => {
    if (!orderRequest.planeList || orderRequest.planeList.length === 0) {
      return null;
    }
    return orderRequest.planeList.find(plane => plane.orderRequestStatusId === OrderRequestPlaneStatusEnum.STATUS_APPROVED_BY_BROKER) || null;
  }, [orderRequest.planeList]);

  // Находим самолеты со статусами (не pending) - статусы 2, 3, 4, 5
  const planesWithStatuses = useMemo(() => {
    if (!orderRequest.planeList || orderRequest.planeList.length === 0) {
      return [];
    }
    return orderRequest.planeList.filter(plane => 
      plane.orderRequestStatusId && 
      plane.orderRequestStatusId !== OrderRequestPlaneStatusEnum.STATUS_PENDING
    );
  }, [orderRequest.planeList]);

  // Вычисляем среднюю цену для самолетов со статусами
  const averagePrice = useMemo(() => {
    if (planesWithStatuses.length === 0) {
      return null;
    }
    
    const planesWithPrice = planesWithStatuses.filter(plane => {
      const price = plane.operatorPrice ? parseFloat(plane.operatorPrice) : null;
      return price !== null && !isNaN(price) && price > 0;
    });

    if (planesWithPrice.length === 0) {
      return null;
    }

    const totalPrice = planesWithPrice.reduce((sum, plane) => {
      const price = parseFloat(plane.operatorPrice!);
      return sum + price;
    }, 0);

    const avg = totalPrice / planesWithPrice.length;
    
    // Определяем валюту (берем первую доступную)
    const currency = planesWithPrice[0]?.operatorCurrency || planesWithPrice[0]?.currency;
    
    return {
      amount: avg,
      currency: currency
    };
  }, [planesWithStatuses]);

  const approvedPlanePrice = approvedPlane?.operatorPrice ? parseFloat(approvedPlane.operatorPrice) : undefined;
  const approvedPlaneCurrency = approvedPlane?.operatorCurrency || approvedPlane?.currency;

  // Преобразуем planesWithStatuses в RequestOffer[] для модалки в режиме просмотра
  const planesWithStatusesOffers = useMemo(() => {
    if (planesWithStatuses.length === 0) {
      return [];
    }

    const firstRouteRequest = orderRequest.orderRouteOrderRequests[0];
    const firstRoute = firstRouteRequest.orderRoute;
    const lastRouteRequest = orderRequest.orderRouteOrderRequests[orderRequest.orderRouteOrderRequests.length - 1];
    const lastRoute = lastRouteRequest.orderRoute;
    
    // Формируем даты и время в UTC (для модалки RespondToRequestModal)
    const departureDate = formatDate(firstRoute.departureDate, 0, "date");
    const departureTime = formatDate(firstRoute.departureDate, 0, "time");
    
    // Для arrival берем дату из последнего маршрута или из arrivalDate если есть
    const arrivalDateSource = lastRouteRequest.arrivalDate ?? lastRoute.departureDate;
    const arrivalDate = formatDate(arrivalDateSource, 0, "date");
    const arrivalTime = formatDate(arrivalDateSource, 0, "time");
    
    const brokerRequestedAmount = typeof orderRequest.price === "number"
      ? new Intl.NumberFormat("ru-RU").format(orderRequest.price)
      : "—";
    const brokerRequestedCurrency = orderRequest.currency?.name ?? "";
    const brokerRequestedCurrencyId = orderRequest.currency?.id;
    
    const passengers = Math.max(...orderRequest.orderRouteOrderRequests.map(route => route.orderRoute.pax ?? 0), 0);
    
    return planesWithStatuses.map((planeItem) => {
      // Определяем статус на основе orderRequestStatusId
      let status: RequestOffer["status"] = "pending";
      if (planeItem.orderRequestStatusId === OrderRequestPlaneStatusEnum.STATUS_OFFERED_BY_OPERATOR) {
        status = "accepted"; // Предложено оператором = принято
      } else if (planeItem.orderRequestStatusId === OrderRequestPlaneStatusEnum.STATUS_DECLINED_BY_OPERATOR || 
                 planeItem.orderRequestStatusId === OrderRequestPlaneStatusEnum.STATUS_DECLINED_BY_BROKER) {
        status = "declined"; // Отклонено
      } else if (planeItem.orderRequestStatusId === OrderRequestPlaneStatusEnum.STATUS_APPROVED_BY_BROKER) {
        status = "accepted"; // Одобрено брокером = принято
      }

      const aircraftCode = planeItem.plane?.registrationNumber ?? "";
      const offerAmount = planeItem.operatorPrice || planeItem.preliminaryPrice || "";
      const offerCurrency = planeItem.operatorCurrency?.name || planeItem.currency?.name || brokerRequestedCurrency || "USD";
      const offerCurrencyId = planeItem.operatorCurrencyId || planeItem.currency?.id;
      
      // Use plane's currency (from calculator) as the main currency for requested price
      const planeCurrency = planeItem.plane?.flyHourCurrency;
      const planeCurrencyId = planeCurrency?.id;
      const planeCurrencyName = planeCurrency?.name || "";
      
      // Use plane's currency as the main currency for requested price display
      // Pass broker's currency ID so modal can convert broker's price to plane's currency
      const requestedCurrency = planeCurrencyName || brokerRequestedCurrency;
      const requestedCurrencyId = planeCurrencyId || brokerRequestedCurrencyId;
      const requestedAmount = brokerRequestedAmount; // Broker's requested amount (will be converted to plane's currency in modal if needed)

      // Конвертируем flightDurationMinutes в формат "Xh Ym"
      let planeFlightDuration = "—";
      if (planeItem.flightDurationMinutes !== undefined && planeItem.flightDurationMinutes !== null) {
        const planeTotalMinutes = planeItem.flightDurationMinutes;
        const planeHours = Math.floor(planeTotalMinutes / 60);
        const planeMinutes = planeTotalMinutes % 60;
        planeFlightDuration = formatFlightDuration(planeHours, planeMinutes);
      }

      // Use adjusted departure and arrival times from planesList if available
      let planeDepartureDate = departureDate;
      let planeDepartureTime = departureTime;
      let planeArrivalDate = arrivalDate;
      let planeArrivalTime = arrivalTime;
      
      // Parse adjusted departure date/time from planeItem (format: "Y-m-d H:i:s")
      if (planeItem.departureDate) {
        try {
          const adjustedDeparture = new Date(planeItem.departureDate);
          if (!isNaN(adjustedDeparture.getTime())) {
            planeDepartureDate = formatDate(adjustedDeparture, 0, "date");
            planeDepartureTime = formatDate(adjustedDeparture, 0, "time");
          }
        } catch (error) {
          console.error('[OrderRequestCard] Error parsing departureDate:', error);
        }
      }
      
      // Parse adjusted arrival date/time from planeItem (format: "Y-m-d H:i:s")
      if (planeItem.arrivalDate) {
        try {
          const adjustedArrival = new Date(planeItem.arrivalDate);
          if (!isNaN(adjustedArrival.getTime())) {
            planeArrivalDate = formatDate(adjustedArrival, 0, "date");
            planeArrivalTime = formatDate(adjustedArrival, 0, "time");
          }
        } catch (error) {
          console.error('[OrderRequestCard] Error parsing arrivalDate:', error);
          // Fallback: calculate arrival from departure + flightDurationMinutes
          if (planeItem.flightDurationMinutes !== undefined && planeItem.flightDurationMinutes !== null) {
            const adjustedDeparture = planeItem.departureDate ? new Date(planeItem.departureDate) : firstRoute.departureDate;
            if (!isNaN(adjustedDeparture.getTime())) {
              const calculatedArrivalDate = new Date(adjustedDeparture.getTime() + planeItem.flightDurationMinutes * 60000);
              planeArrivalDate = formatDate(calculatedArrivalDate, 0, "date");
              planeArrivalTime = formatDate(calculatedArrivalDate, 0, "time");
            }
          }
        }
      } else if (planeItem.flightDurationMinutes !== undefined && planeItem.flightDurationMinutes !== null) {
        // Fallback: calculate arrival from adjusted departure + flightDurationMinutes
        const adjustedDeparture = planeItem.departureDate ? new Date(planeItem.departureDate) : firstRoute.departureDate;
        if (!isNaN(adjustedDeparture.getTime())) {
          const calculatedArrivalDate = new Date(adjustedDeparture.getTime() + planeItem.flightDurationMinutes * 60000);
          planeArrivalDate = formatDate(calculatedArrivalDate, 0, "date");
          planeArrivalTime = formatDate(calculatedArrivalDate, 0, "time");
        }
      }

      return {
        id: `${orderRequest.id}-${planeItem.orderRequestPlaneId}-${firstRoute.id}`,
        aircraftCode,
        planeId: planeItem.planeId,
        orderRequestPlaneId: planeItem.orderRequestPlaneId,
        departureDate: planeDepartureDate,
        departureTime: planeDepartureTime,
        arrivalDate: planeArrivalDate,
        arrivalTime: planeArrivalTime,
        requestedAmount,
        requestedCurrency,
        requestedCurrencyId,
        brokerRequestedCurrencyId, // Pass broker's currency ID for conversion
        offerAmount,
        offerCurrency,
        offerCurrencyId,
          flightDuration: planeFlightDuration,
          passengers,
          refuels: planeItem.refuelingCount ?? 0,
          status,
          positioningDurationMinutes: planeItem.positioningDurationMinutes,
          positioningDistanceKm: planeItem.positioningDistanceKm,
          positioningFromAirportId: planeItem.positioningFromAirportId,
          positioningDepartureDate: planeItem.positioningDepartureDate,
        };
    });
  }, [planesWithStatuses, orderRequest, offset]);

  // Показываем секцию с самолетами если есть самолеты со статусами и нет approvedPlane
  const planesSummarySection = !approvedPlane && planesWithStatuses.length > 0 && (
    <PlanesSummarySection onClick={() => {
      setIsRespondModalReadOnly(true);
      setIsRespondModalVisible(true);
    }}>
      <div>
        <div>
          {intl.formatMessage({id: 'orderRequestCard.planesCount', defaultMessage: 'Planes: {count}'}, {
            count: planesWithStatuses.length
          })}
        </div>
        {averagePrice && averagePrice.currency && (
          <div>
            {intl.formatMessage({id: 'orderRequestCard.averagePrice', defaultMessage: 'avg. {price}'}, {
              price: DisplayFlyPrice(averagePrice.amount, averagePrice.currency)
            })}
          </div>
        )}
      </div>
      <div>
        <CaretRight />
      </div>
    </PlanesSummarySection>
  );

  const offerButtons = !approvedPlane && planesWithStatuses.length === 0 && <>
    <CustomButton type={'primary'} ghost heightSize={'m'} style={{flexGrow: 1}}
                  onClick={() => setIsBrokerDrawerOrderRequestOpen(true)}>
      {intl.formatMessage(CommonButtonMessages.look)}
    </CustomButton>
    {!isOrderDeclinedByBroker && !orderRequest.isArchived && (
      <CustomButton type={'primary'} heightSize={'m'}
                    style={{flexGrow: 1, marginTop: isMobile ? 8 : 0}}
                    // onClick={() => setIsMakeOfferDrawerOpen(true)}>
                    onClick={() => setIsRespondModalVisible(true)}>
        {intl.formatMessage(OrderRequestCardMessages.offer)}
      </CustomButton>
    )}
  </>

  const offerDetails = approvedPlane && approvedPlane.plane && approvedPlanePrice && approvedPlaneCurrency &&
    (isMobile ? <OfferDetailsMobile onClick={() => setIsFlightDrawerOrderRequestOpen(true)}>
        <div>
          <div>
            <div>{approvedPlane.plane.planeType.name}</div>
            <div>{DisplayFlyPrice(approvedPlanePrice, approvedPlaneCurrency)}</div>
          </div>
        </div>
        <CaretRight/>
      </OfferDetailsMobile>
      : <OfferDetails onClick={() => setIsFlightDrawerOrderRequestOpen(true)}>
        <div>
          <div>
            <div>{approvedPlane.plane.planeType.name}</div>
            <div>{DisplayFlyPrice(approvedPlanePrice, approvedPlaneCurrency)}</div>
          </div>
        </div>
        <CaretRight/>
      </OfferDetails>);


  const allModals = <>
    {isArchiveModalOpen &&
      <ArchiveOrderRequestModal orderRequestId={orderRequest.id} isModalVisible={isArchiveModalOpen}
                                setIsModalVisible={setIsArchiveModalOpen} itinerary={archiveItinerary}/>}

    {isBrokerDrawerOrderRequestOpen &&
      <OrderRequestBrokerDrawer orderRequest={orderRequest}
                                isOpen={isBrokerDrawerOrderRequestOpen}
                                setIsOpen={setIsBrokerDrawerOrderRequestOpen}
                                openChat={() => setIsChatOpened(true)}
                                openArchive={() => setIsArchiveModalOpen(true)}
                                // openMakeOffer={() => setIsMakeOfferDrawerOpen(true)}/>}
                                openMakeOffer={() => setIsRespondModalVisible(true)}/>}

    {isFlightDrawerOrderRequestOpen && approvedPlane &&
      <OrderRequestOrderRouteFlightDrawer orderRequest={orderRequest} isOpen={isFlightDrawerOrderRequestOpen}
                                          setIsOpen={setIsFlightDrawerOrderRequestOpen}
                                          openChat={() => setIsChatOpened(true)}/>}

    {isChatOpened && chat &&
      <ChatModal chat={chat}
                 isVisible={isChatOpened} setIsVisible={setIsChatOpened}
      />}

    {/*{isMakeOfferDrawerOpen && <MakeOfferDrawer orderRequest={orderRequest}*/}
    {/*                                           isOpen={isMakeOfferDrawerOpen}*/}
    {/*                                           setIsOpen={setIsMakeOfferDrawerOpen}/>}*/}

    {isRespondModalVisible && (
      <RespondToRequestModal
        visible={isRespondModalVisible}
        onClose={() => {
          setIsRespondModalVisible(false);
          setIsRespondModalReadOnly(false);
        }}
        requestName={requestTitle}
        orderRequestId={orderRequest.id}
        offers={isRespondModalReadOnly ? planesWithStatusesOffers : respondModalOffers}
        onSubmit={() => {
          setIsRespondModalVisible(false);
          setIsRespondModalReadOnly(false);
        }}
        readOnly={isRespondModalReadOnly}
        onSuccess={onOfferSubmitSuccess}
        airportFrom={firstRoute.airportFrom}
        airportTo={lastRoute.airportTo}
        brokerComment={orderRequest.order.comment}
        orderRouteOrderRequests={orderRequest.orderRouteOrderRequests}
      />
    )}

    <PastResponsesModal
      visible={isPastResponsesModalOpen}
      onClose={() => setIsPastResponsesModalOpen(false)}
      routeFrom={firstRoute.airportFrom}
      routeTo={lastRoute.airportTo}
      allRouteAirports={allOrderAirports}
      orderRequestId={orderRequest.id}
    />

    {isScheduleCreateModalOpen && approvedPlane &&
      <ScheduleCreateFromOrderModal
        isModalVisible={isScheduleCreateModalOpen}
        setIsModalVisible={setIsScheduleCreateModalOpen}
        orderRequest={orderRequest}
        approvedPlane={approvedPlane}
      />
    }
  </>

  if (isMobile) {
    return <OrderRequestCardWrapperMobile>
      <OrderRequestBrokerInfo>
        <img src={orderRequest.order.company.avatar?.url || defaultAvatar} alt="avatar"/>

        <div>
          <div>{formatDate(orderRequest.order.createdDate, offset, "datetime_short_year")}</div>
          <div>{DisplayManagerFullName(orderRequest.order.manager)}</div>
          <div onClick={() => setIsBrokerDrawerOrderRequestOpen(true)}>{orderRequest.order.company.name}</div>
        </div>

        <ChatButton hasNewMessages={unreadChatNotifications.length > 0} onClick={onChatOpen}
                    style={{marginLeft: "auto"}}/>
      </OrderRequestBrokerInfo>

      <OrderRequestCardOrderTypeAndRouteMobile isOrderDeclined={isOrderDeclinedByBroker}>
        <OrderTypeShield type={orderRequest.order.type}/>
        <OrderRequestOrderRoutesAndStatusMobile>
          <OrderRequestOrderRoutes>
            <div>
              {renderDateWithUrgency(firstRoute.departureDate, offset, isOnlyRoute ? "datetime" : "date")}
              {!isOnlyRoute && (
                <>
                  {' – '}
                  {renderDateWithUrgency(lastRoute.departureDate, offset, "date")}
                </>
              )}
            </div>
            <FlyRouteMini airports={allOrderAirports} onMoreClick={() => setIsBrokerDrawerOrderRequestOpen(true)}/>
          </OrderRequestOrderRoutes>
          {isOrderDeclinedByBroker &&
            <DeclinedShield>{intl.formatMessage(OrderRequestCardMessages.orderRouteArchivedByBroker)}</DeclinedShield>}
        </OrderRequestOrderRoutesAndStatusMobile>
      </OrderRequestCardOrderTypeAndRouteMobile>

      {planesSummarySection}
      {offerButtons}
      {offerDetails}

      {!orderRequest.isArchived && (
        <Tooltip title={intl.formatMessage(CommonButtonMessages.archive)}>
          <CustomLinkButton icon={<CloseIcon/>} onClick={() => setIsArchiveModalOpen(true)}
                           style={{paddingTop: 16}}>{intl.formatMessage(CommonButtonMessages.archive)}</CustomLinkButton>
        </Tooltip>
      )}

      {allModals}
    </OrderRequestCardWrapperMobile>
  }

  return (
    <OrderRequestCardWrapper>
      <OrderRequestCardBroker>
        <OrderRequestBrokerInfo>
          <img src={orderRequest.order.company.avatar?.url || defaultAvatar} alt="avatar"/>

          <div>
            <div>{formatDate(orderRequest.order.createdDate, offset, "datetime_short_year")}</div>
            <div>{DisplayManagerFullName(orderRequest.order.manager)}</div>
            <div onClick={() => setIsBrokerDrawerOrderRequestOpen(true)}>{orderRequest.order.company.name}</div>
          </div>
        </OrderRequestBrokerInfo>

        <ChatButton hasNewMessages={unreadChatNotifications.length > 0} onClick={onChatOpen}/>
      </OrderRequestCardBroker>

      <OrderRequestCardOrder>
        <OrderRequestOrderType isOrderDeclined={isOrderDeclinedByBroker}>
          <OrderTypeShield type={orderRequest.order.type}/>
        </OrderRequestOrderType>

        <OrderVerticalDivider/>

        <OrderRequestOrderRoutes isOrderDeclined={isOrderDeclinedByBroker}>
          <div>
            {renderDateWithUrgency(firstRoute.departureDate, offset, isOnlyRoute ? "datetime" : "date")}
            {!isOnlyRoute && (
              <>
                {' – '}
                {renderDateWithUrgency(lastRoute.departureDate, offset, "date")}
              </>
            )}
          </div>
          <FlyRouteMini airports={allOrderAirports} onMoreClick={() => setIsBrokerDrawerOrderRequestOpen(true)}/>
        </OrderRequestOrderRoutes>

        <OrderRequestOfferSection>
          {!orderRequest.isArchived && <>
            <Tooltip title={intl.formatMessage({ id: 'orderRequestCardMessages.findSimilarOrders', defaultMessage: 'Find similar orders' })}>
              <ActionButtonWrapper onClick={handleDocumentSearch} heightSize={'m'}>
                <DocumentSearchIcon/>
              </ActionButtonWrapper>
            </Tooltip>
            <Tooltip title={isFavorite 
              ? intl.formatMessage({ id: 'orderRequestCardMessages.removeFromFavorites', defaultMessage: 'Remove from favorites' })
              : intl.formatMessage({ id: 'orderRequestCardMessages.addToFavorites', defaultMessage: 'Add to favorites' })
            }>
              <FavoriteButtonWrapper
                heightSize={'m'}
                $isFavorite={isFavorite}
                icon={
                  isFavorite ? 
                    <FlagFilledIcon style={{color: "#1890FF"}}/> : 
                    <FlagIcon/>
                }
                onClick={() => {
                  const newFavoriteState = !isFavorite;
                  setIsFavorite(newFavoriteState);
                  dispatch(updateOrderRequestFavorite({
                    orderRequestId: orderRequest.id,
                    isFavorite: newFavoriteState,
                  }));
                }}
              />
            </Tooltip>
            <Tooltip title={intl.formatMessage(CommonButtonMessages.archive)}>
              <StatusButton
                type="button"
                $variant="decline"
                $active={false}
                onClick={() => setIsArchiveModalOpen(true)}
              >
                <CloseIcon />
              </StatusButton>
            </Tooltip>
          </>}
          {planesSummarySection}
          {offerButtons}
          {offerDetails}
        </OrderRequestOfferSection>

        {isOrderDeclinedByBroker &&
            <DeclinedShield>{intl.formatMessage(OrderRequestCardMessages.orderRouteArchivedByBroker)}</DeclinedShield>}
      </OrderRequestCardOrder>

      {allModals}
    </OrderRequestCardWrapper>
  );
};
